import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles, Palette, Heart, BookOpen } from 'lucide-react';
export function SolutionBenefits() {
  const benefits = [{
    icon: <Sparkles className="w-5 h-5" data-id="element-284" />,
    title: 'Diseños por raza, no genéricos',
    text: <>
          Cada patrón respeta la{' '}
          <span className="text-soft-sage font-semibold" data-id="element-285">anatomía real</span> de
          la raza: las orejas, el hocico, la expresión única.
        </>
  }, {
    icon: <Palette className="w-5 h-5" data-id="element-286" />,
    title: 'Personaliza colores y manchas',
    text: <>
          Guía incluida para adaptar cada patrón al{' '}
          <span className="text-soft-sage font-semibold" data-id="element-287">
            color exacto de TU mascota
          </span>
          . Que sea idéntico.
        </>
  }, {
    icon: <Heart className="w-5 h-5" data-id="element-288" />,
    title: 'Un resultado que emociona',
    text: <>
          Cuando lo vean, van a decir:{' '}
          <span className="text-soft-sage font-semibold" data-id="element-289">"¡Es igualito!"</span>.
          Prepárate para las lágrimas de emoción.
        </>
  }, {
    icon: <BookOpen className="w-5 h-5" data-id="element-290" />,
    title: 'Paso a paso sin frustraciones',
    text: <>
          Nivel intermedio con{' '}
          <span className="text-soft-sage font-semibold" data-id="element-291">
            instrucciones claras
          </span>
          . Si sabes hacer anillo mágico y puntos bajos, puedes lograrlo.
        </>
  }];
  return <section className="py-16 md:py-24 bg-white" data-id="element-292">
      <div className="max-w-5xl mx-auto px-4" data-id="element-293">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-14" data-id="element-294">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-deep-brown" data-id="element-295">
            Imagina poder tejer{' '}
            <span className="text-warm-brown italic" data-id="element-296">exactamente</span> a tu
            mascota
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-5" data-id="element-297">
          {benefits.map((benefit, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.08,
          duration: 0.4
        }} className="etsy-card etsy-card-hover p-6" data-id="element-298">
              <div className="w-10 h-10 rounded-full bg-cream flex items-center justify-center text-warm-brown mb-4" data-id="element-299">
                {benefit.icon}
              </div>
              <h3 className="font-bold text-deep-brown mb-2" data-id="element-300">
                {benefit.title}
              </h3>
              <p className="text-gray-500 text-sm leading-relaxed" data-id="element-301">
                {benefit.text}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}